import classNames from "classnames";

export function Tag(
	props: React.HTMLProps<HTMLDivElement> & { type: "Dark" | "Light" }
) {
	return (
		<div
			{...props}
			className={classNames(
				props.className,
				"flex h-fit w-fit flex-col justify-center rounded-sm p-1 text-xs",
				{
					"bg-base-dark text-sesh-primary": props.type === "Dark",
					"bg-sesh-primary text-black": props.type === "Light",
				}
			)}
		></div>
	);
}
